'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
export default class DropdownFormFooter extends PureComponent {
  render() {
    const {
      children,
      className
    } = this.props;
    const footerClasses = classNames('m-top-6', className);
    return /*#__PURE__*/_jsx("footer", {
      className: footerClasses,
      children: children
    });
  }

}
DropdownFormFooter.displayName = 'DropdownFormFooter';
DropdownFormFooter.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};
DropdownFormFooter.defaultProps = {
  children: null,
  className: ''
};